import { useSidebarStore } from "@/Components/Layout/Store";
import Avatar from "@/Components/Avatar";
import { useLoginStore } from "@/Modules/Auth/Login/Store";
import { showErrorAlert, showSuccessAlert, resolveAvatarUrl } from "@/Utils";
import { useRedirect } from "@/hooks";
import useApi from "@/hooks/useApi";
import type { Ref } from "react";
import { GoArrowRight } from "react-icons/go";
import { MdLogout } from "react-icons/md";
import { Link } from "react-router-dom";

import S from "./styles.module.scss";
import { useCompanyStore, useLoggedUserStore } from "@/Store";

interface BoxProfileProps {
  name?: string;
  email?: string;
  image?: string | null;
  ref?: Ref<HTMLDivElement>;
}

const BoxProfile = ({ name, email, image, ref }: BoxProfileProps) => {
  const { closeBoxProfile } = useSidebarStore();
  const redirect = useRedirect();
  const { postRequest, error } = useApi();
  const { clearSession } = useLoginStore();
  const clearCompanyContext = useCompanyStore(
    (state) => state.clearCompanyContext
  );
  const setLoggedUser = useLoggedUserStore((state) => state.setLoggedUser);

  const handleLogout = async () => {
    try {
      await postRequest("/api/auth/logout", {});
      showSuccessAlert("Sua sessão foi encerrada com sucesso!");
    } catch {
      showErrorAlert(error || "Não foi possível encerrar a sessão na API.");
    } finally {
      clearSession();
      clearCompanyContext();
      setLoggedUser(null);
      closeBoxProfile();
      redirect("/login");
    }
  };

  return (
    <div ref={ref} className={S["box-container"]}>
      <div className={S["box-content"]}>
        <div className={S["box-header"]}>
          <Avatar size={44} src={resolveAvatarUrl(image)} />
          <div className={S["box-header-info"]}>
            <p>{name ?? ""}</p>
            <span>{email ?? ""}</span>
          </div>
        </div>
        <ul className={S["box-menu-list"]}>
          <li className={S["box-menu-item"]}>
            <Link
              to="/perfil"
              onClick={closeBoxProfile}
              className={S["link-icon"]}
            >
              Gerenciar conta <GoArrowRight size={18} />
            </Link>
          </li>
          <button
            type="button"
            className={S["btn-logout"]}
            onClick={handleLogout}
          >
            Sair <MdLogout size={18} />
          </button>
        </ul>
      </div>
    </div>
  );
};

export default BoxProfile;
